import { PropsWithChildren } from 'react';

export default function PolarisContent(props: PropsWithChildren<unknown>) {
  return <div style={{ backgroundColor: 'var(--p-background)', paddingBottom: '2rem' }}>{props.children}</div>;
}
